import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, FormGroup, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import RegisteredBusSelect from '../../../common/forms/select/RegisteredBusSelect';
import DatePicker from '../../../common/forms/input/DatePicker';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

const TollLiquidationItinerarySearchForm = ({ handleSubmit }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Bus" required>
        <Field
          name="registeredBusId"
          component={RegisteredBusSelect}
          isClearable={false}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={DatePicker}
          validate={[isRequired, validateDate]}
        />
      </FormItem>
    </FormGroup>
    <Row>
      <Col className="flex row-reverse">
        <Button type="submit" outline>
          <i className="fa fa-search" /> Buscar
        </Button>
      </Col>
    </Row>
  </Form>
);

TollLiquidationItinerarySearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'TollLiquidationItinerarySearchForm',
})(TollLiquidationItinerarySearchForm);
